import axiosCommon from '@/axios-common/axios-common';
import InfiniteLoading from 'vue-infinite-loading';
import vSelect from 'vue-select';
import { flatpickrConfig } from '../../../config';

export default {
    name: 'tenderAndProcurementDashboard',
    dependencies:['localeService'],
    components: {
        InfiniteLoading,
        vSelect
    },
    mounted() {
        this.initialize()
    },
    data() {
        return {
            tenderAndProcurements: [],
            flatpickrConfig,
            search: {
                fromDate:'',
                toDate:'',
                dateRange: '',
                tenderStatuses: [],
                formOfContracts: [],
                tenderCategories: [],
                tenderTypes: [],
                productCategories: []
            },
            tenderStatusCustomFieldId: 76,
            formOfContractCustomFieldId: 77,
            tenderCategoryCustomFieldId: 78,
            tenderTypeCustomFieldId: 79,
            productCategoryCustomFieldId: 80,
            tenderStatuses: [],
            formOfContracts: [],
            tenderCategories: [],
            tenderTypes: [],
            productCategories: [],
            skip: 0,
            take: 5
        }
    },
    methods: {
        initialize() {
            let vm = this;

            vm.getCustomFields([
                vm.tenderStatusCustomFieldId,
                vm.formOfContractCustomFieldId,
                vm.tenderCategoryCustomFieldId,
                vm.tenderTypeCustomFieldId,
                vm.productCategoryCustomFieldId
            ]).then(function (res) {
                vm.tenderStatuses = res.data[vm.tenderStatusCustomFieldId];
                vm.formOfContracts = res.data[vm.formOfContractCustomFieldId];
                vm.tenderCategories = res.data[vm.tenderCategoryCustomFieldId];
                vm.tenderTypes = res.data[vm.tenderTypeCustomFieldId];
                vm.productCategories = res.data[vm.productCategoryCustomFieldId];
            }).catch(function (err) {
                console.log(err);
                return err
            })

            return vm.getTenderAndProcurements()
                .then(function (res) {
                    if (res.data.length > 0) {
                        vm.tenderAndProcurements = res.data;
                    }
                })
                .catch(function (err) {
                    console.log(err);
                    return err;
                });
        },

        infiniteHandler($state) {
            let vm = this;
            vm.skip += vm.take;
            vm.getTenderAndProcurements()
                .then(function (res) {
                    vm.tenderAndProcurements = vm.tenderAndProcurements.concat(res.data);
                    $state.loaded();
                    if (res.data.length == 0) {
                        $state.complete()
                    }
                })
                .catch(function (err) {
                    console.log(err);
                    return err;
                });

        },
        filter() {
            let vm = this;
            vm.skip = 0;
            vm.take = 0;
            let datesArr = vm.search.dateRange.trim().split('to')
            if (datesArr.length > 1) {
                vm.search.fromDate = datesArr[0].trim();
                vm.search.toDate = datesArr[1].trim();
            }
            vm.getTenderAndProcurements()
                .then(function (res) {
                    vm.tenderAndProcurements = res.data;
                })
                .catch(function (err) {
                    console.log(err);
                    return err;
                });
        },
        getCustomFields(ids) {
            let vm = this;

            let customFieldsURL = 'o/customFields?';

            for (let [index, id] of ids.entries()) {
                if (index == 0) {
                    customFieldsURL += `id=${id}`
                } else {
                    customFieldsURL += `&id=${id}`
                }
            }
            return axiosCommon.get(customFieldsURL)
        },
        getTenderAndProcurements() {
            let vm = this;
            return axiosCommon.get(`o/tenderAndProcurements?language=English&skip=${vm.skip}&take=${vm.take}&tenderStatuses=${vm.search.tenderStatuses.toString()}&formOfContracts=${vm.search.formOfContracts.toString()}&tenderCategories=${vm.search.tenderCategories.toString()}&tenderTypes=${vm.search.tenderTypes.toString()}&productCategories=${vm.search.productCategories.toString()}&fromDate=${vm.search.fromDate.toString()}&toDate=${vm.search.toDate}`)
        },
        getAttachmentType(attachmentPath){
            let vm = this;
            
            if(attachmentPath !== undefined && attachmentPath.trim() !== ""){
                let arr = attachmentPath.split('.');
                return arr[arr.length-1];
            }
        }
    }
}


// WEBPACK FOOTER //
// ./src/components/tender-and-procurement-dashboard/tender-and-procurement-dashboard.js